import styled from 'styled-components';

export const ProductPicture = styled.img`
  width: 40px;
  height: 40px;
  min-width: 40px;

  border-radius: 4px;
  object-fit: cover;
`;

export const ProductNames = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  min-width: 0;

  > * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
